import { API_BASE_URL } from "../app_url";
import axios from "axios";
import { toast } from "react-toastify";

// Add a response interceptor to handle subscription expired errors (403)
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403 && error.response?.data?.message) {
      toast.error(error.response.data.message, { autoClose: 5000 });
    } else if (error.response?.status === 403) {
      toast.error("Votre abonnement a expiré. Veuillez renouveler votre abonnement pour continuer.", { autoClose: 5000 });
    }
    return Promise.reject(error);
  }
);

const getHeader = () => {
  try {
    let value = typeof localStorage !== "undefined" ? JSON.parse(localStorage.getItem("doctolikLoginInfo")) : null;
    let token = value?.authorisation?.token || value?.token || "";
    let header = {
      headers: {
        ...(token ? { Authorization: "Bearer " + token } : {}),
        'Cache-Control': 'no-cache', // Disable cache
      },
    };
    return header;
  } catch {
    return {
      headers: {
        'Cache-Control': 'no-cache',
      },
    };
  }
};

export const cityListApi = values => {
  return axios.get(API_BASE_URL + `patient/cityList`, {
    ...getHeader(),
    ...(values || {}),
  });
};

export const getMunicipalityApi = values => {
  return axios.post(API_BASE_URL + `home/municipalityList`, values);
};

export const signUpApi = values => {
  return axios.post(API_BASE_URL + `patient/sign-up`, values);
};

export const forgotPasswordApi = values => {
  return axios.post(API_BASE_URL + `patient/forgot-password`, values);
};

export const updatePasswordApi = values => {
  return axios.post(API_BASE_URL + `patient/update-password`, values);
};

export const signUpSendVerificationMessageApi = values => {
  return axios.post(API_BASE_URL + `patient/signUpSendVerificationMessage`, values);
};

export const signUpVerifyAccountApi = values => {
  return axios.post(API_BASE_URL + `patient/signUpVerifyAccount`, values);
};

export const loginApi = values => {
  return axios.post(API_BASE_URL + `patient/login`, values);
};

// TODO this used as a doctor information retrevier, how ever it's patient prefix!!!!
export const myAccountDetailsApi = () => {
  return axios.post(API_BASE_URL + `patient/MyAccountDetails`, {}, getHeader());
};

export const updateProfilePictureApi = values => {
  return axios.post(API_BASE_URL + `patient/updateProfilePicture`, values, getHeader());
};

export const removeProfilePictureApi = values => {
  return axios.post(API_BASE_URL + `patient/removeProfilePicture`, {}, getHeader());
};

export const updateMyAccountApi = values => {
  return axios.post(API_BASE_URL + `patient/updateMyAccount`, values, getHeader());
};

export const changePasswordApi = values => {
  return axios.post(API_BASE_URL + `patient/change-password`, values, getHeader());
};

export const updateOtpApi = values => {
  return axios.post(API_BASE_URL + `patient/sendPhoneUpdateRequest`, values, getHeader());
};

export const updatePhoneNumberApi = values => {
  return axios.post(API_BASE_URL + `patient/updatePhoneNumber`, values, getHeader());
};

export const updateShowPhoneNumberApi = values => {
  return axios.post(API_BASE_URL + `patient/showPhoneNumberToDoctor`, values, getHeader());
};

export const getSpecialityApi = () => {
  return axios.get(API_BASE_URL + `home/get-speciality`);
};

export const requestDoctorApi = values => {
  return axios.post(API_BASE_URL + `home/request-doctor`, values);
};

export const doctorLoginApi = values => {
  return axios.post(API_BASE_URL + `user/login`, values);
};

export const fetchNormalAvailabilityApi = () => {
  return axios.get(API_BASE_URL + `doctor/fetch-normal-availability`, getHeader());
};

export const deleteNormalAvailabilityApi = values => {
  return axios.post(API_BASE_URL + `doctor/delete-normal-availability`, values, getHeader());
};

export const addNormalAvailabilityApi = values => {
  return axios.post(API_BASE_URL + `doctor/add-normal-availability`, values, getHeader());
};

export const addDateAvailabilityApi = values => {
  return axios.post(API_BASE_URL + `doctor/add-date-availability`, values, getHeader());
};

export const fetchDateChangeAvailabilityApi = values => {
  return axios.post(API_BASE_URL + `doctor/fetch-date-change-availability`, values, getHeader());
};

export const deleteDateAvailabilityApi = values => {
  return axios.post(API_BASE_URL + `doctor/delete-date-availability`, values, getHeader());
};

export const fetchHolidayApi = values => {
  return axios.post(API_BASE_URL + `doctor/fetch-holiday`, values, getHeader());
};

export const doctorHolidayActionApi = values => {
  return axios.post(API_BASE_URL + `doctor/doctor-holiday-action`, values, getHeader());
};

export const getLanguagesApi = () => {
  return axios.get(API_BASE_URL + `home/get-languages`);
};

export const getFaqsApi = () => {
  return axios.get(API_BASE_URL + `home/get-faqs`);
};

export const fetchDoctorInfoApi = () => {
  return axios.get(API_BASE_URL + `doctor/fetch-info`, getHeader());
};

export const updateDoctorInfoApi = values => {
  return axios.post(API_BASE_URL + `doctor/update-info`, values, getHeader());
};

export const deleteDoctorInfoApi = values => {
  return axios.post(API_BASE_URL + `doctor/delete-info`, values, getHeader());
};

export const getPatientAppointmentApi = type => {
  return axios.get(API_BASE_URL + `appointment/getAppointment?type=${type}`, getHeader());
};

export const getAppointmentDetailsApi = id => {
  return axios.get(API_BASE_URL + `appointment/getAppointmentDetails?id=${id}`, getHeader());
};

export const addNurseByDoctorApi = values => {
  return axios.post(API_BASE_URL + `doctor/create-nurse`, values, getHeader());
};

export const editNurseByDoctorApi = values => {
  return axios.post(API_BASE_URL + `doctor/update-nurse`, values, getHeader());
};

export const fetchNurseByDoctorApi = () => {
  return axios.get(API_BASE_URL + `doctor/fetch-nurse`, getHeader());
};

export const deleteNurseByDoctorApi = values => {
  return axios.post(API_BASE_URL + `doctor/delete-nurse`, values, getHeader());
};

export const getDoctorDashboardApi = values => {
  return axios.post(API_BASE_URL + `doctor/dashboard`, values, getHeader());
};

export const getAppointmentBookingStep1 = values => {
  return axios.get(API_BASE_URL + `patient/add-appointment-step1`, {
    params: values,
    ...getHeader()
  });
};

export const addPatientMemberApi = values => {
  return axios.post(API_BASE_URL + `patient/add-member`, values, getHeader());
};

export const dateAvailabilityApi = values => {
  return axios.post(API_BASE_URL + `patient/date-availability`, values, getHeader());
};

export const createAppointmentApi = values => {
  return axios.post(API_BASE_URL + `patient/create-appointment`, values, getHeader());
};

export const doctorUpdateMyAccountApi = values => {
  return axios.post(API_BASE_URL + `doctor/updateMyAccount`, values, getHeader());
};

export const activateAccountApi = values => {
  return axios.post(API_BASE_URL + `patient/activate-account`, values);
};

export const searchDoctorApi = values => {
  return axios.post(API_BASE_URL + `home/fetch-doctor`, values);
};

export const doctorDetailsPatientViewApi = values => {
  return axios.post(API_BASE_URL + `home/doctor-details`, values);
};

export const checkDrugInteractionsApi = values => {
  return axios.post(API_BASE_URL + `v1/drugs/check-interactions`, values, getHeader());
};

export const searchDoctorListApi = values => {
  return axios.post(API_BASE_URL + `home/search-doctor`, values);
};

export const searchAvailableDayListApi = values => {
  return axios.post(API_BASE_URL + `home/search-availableday`, values);
};

export const downloadAppTextApi = () => {
  return axios.get(API_BASE_URL + `home/download-app`);
};

export const patientFetchNoteApi = values => {
  return axios.post(API_BASE_URL + `patient/fetch-note`, values, getHeader());
};

export const createNoteApi = values => {
  return axios.post(API_BASE_URL + `patient/create-note`, values, getHeader());
};

export const doctorFetchAppointmentsApi = values => {
  return axios.post(API_BASE_URL + `doctor/fetch-appointments`, values, getHeader());
};

export const absenceAppointmentApi = values => {
  return axios.post(API_BASE_URL + `doctor/absence-appointment`, values, getHeader());
};

export const getAbsenceReasonApi = () => {
  return axios.get(API_BASE_URL + `home/get-absence-reason`);
};

export const getCancelReasonApi = () => {
  return axios.get(API_BASE_URL + `home/get-cancel-reason`);
};

export const cancelAppointmentApi = values => {
  return axios.post(API_BASE_URL + `doctor/cancel-appointment`, values, getHeader());
};

export const getRescheduleReasonApi = () => {
  return axios.get(API_BASE_URL + `home/get-reschedule-reason`);
};

export const rescheduleAppointmentApi = values => {
  return axios.post(API_BASE_URL + `doctor/reschedule-appointment`, values, getHeader());
};

export const getDelayReasonApi = () => {
  return axios.get(API_BASE_URL + `home/get-delay-reason`);
};

export const appointmentDetailsApi = values => {
  return axios.post(API_BASE_URL + `doctor/details-appointments`, values, getHeader());
};

// TODO make sure to improve this API, it's /patient, but it's used by doctor!!
export const getQuestionApi = values => {
  // Callers pass either a plain object or a FormData — normalise to a params
  // object, otherwise axios silently drops a FormData instance passed as
  // `params` and the request goes out without `doctor_id` (422).
  const params =
    typeof FormData !== "undefined" && values instanceof FormData
      ? Object.fromEntries(values.entries())
      : values;
  return axios.get(API_BASE_URL + `patient/get-question`, {
    params,
    ...getHeader()
  });
};

export const fetchDoctorQuestionnairesApi = (appointmentId = null) => {
  return axios.get(API_BASE_URL + `doctor/questionnaires`, {
    ...getHeader(),
    params: appointmentId ? { appointment_id: appointmentId } : undefined,
  });
};

export const saveDoctorQuestionnairesApi = questionnaires => {
  return axios.put(API_BASE_URL + `doctor/questionnaires`, { questionnaires }, getHeader());
};

export const saveQuestionnaireHistoryApi = values => {
  return axios.post(API_BASE_URL + `doctor/questionnaire-history`, values, getHeader());
};

export const fetchSettingApi = () => {
  return axios.get(API_BASE_URL + `setting/fetch-setting`, getHeader());
};

export const updateSettingApi = values => {
  return axios.post(API_BASE_URL + `setting/update-setting`, values, getHeader());
};

export const fetchQuestionApi = () => {
  return axios.get(API_BASE_URL + `setting/fetch-question`, getHeader());
};

export const visitQuestionApi = values => {
  return axios.post(API_BASE_URL + `setting/visit-question`, values, getHeader());
};

export const updateQuestionApi = values => {
  return axios.post(API_BASE_URL + `setting/update-question`, values, getHeader());
};

export const deleteQuestionApi = values => {
  return axios.post(API_BASE_URL + `setting/delete-question`, values, getHeader());
};

export const deleteOptionApi = values => {
  return axios.post(API_BASE_URL + `setting/delete-option`, values, getHeader());
};

export const updateAppointmentsOrderApi = values => {
  return axios.post(API_BASE_URL + `doctor/updateAppointmentsOrder`, values, getHeader());
};

export const updatePriorityApi = values => {
  return axios.post(API_BASE_URL + `doctor/updatePriority`, values, getHeader());
};

export const delayAppointmentApi = values => {
  return axios.post(API_BASE_URL + `doctor/delay-appointment`, values, getHeader());
};

export const eraseDelayAppointmentApi = values => {
  return axios.post(API_BASE_URL + `doctor/erase-delay-appointment`, values, getHeader());
};

export const getDoctorForSearchApi = values => {
  return axios.post(API_BASE_URL + `doctor/get-doctor`, values, getHeader());
};

export const getAppointmentMessageApi = values => {
  return axios.post(API_BASE_URL + `doctor/fetch-message`, values, getHeader());
};

export const sendAppointmentMessageApi = values => {
  return axios.post(API_BASE_URL + `doctor/send-message`, values, getHeader());
};

export const readAppointmentMessageApi = values => {
  return axios.post(API_BASE_URL + `doctor/read-message`, values, getHeader());
};

export const fetchDoctorMessageListApi = values => {
  return axios.post(API_BASE_URL + `doctor/fetchDoctorMessageList`, values, getHeader());
};

export const fetchDoctorMessageDetailsApi = values => {
  return axios.post(API_BASE_URL + `doctor/fetchDoctorMessageDetails`, values, getHeader());
};

export const readDoctorMessageApi = values => {
  return axios.post(API_BASE_URL + `doctor/read-doctor-message`, values, getHeader());
};

export const chatFetchSearchUserApi = values => {
  return axios.post(API_BASE_URL + `chat/fetch-user`, values, getHeader());
};

export const chatFetchPatientApi = values => {
  return axios.post(API_BASE_URL + `chat/fetch-patient`, values, getHeader());
};

export const fetchPatientMessageDetailsApi = values => {
  return axios.post(API_BASE_URL + `doctor/fetchPatientMessageDetails`, values, getHeader());
};

export const addDoctorTemplateApi = values => {
  return axios.post(API_BASE_URL + `home/add-doctor-template`, values);
};

export const getDoctorTemplateApi = values => {
  return axios.post(API_BASE_URL + `home/get-doctor-template`, values);
};

export const getDoctorOtherTemplateApi = values => {
  return axios.post(API_BASE_URL + `home/get-other-doctor-template`, values);
};

export const checkAdminTokenApi = values => {
  return axios.post(API_BASE_URL + `home/checkadmintoken`, values);
};

export const editDoctorTemplateApi = values => {
  return axios.post(API_BASE_URL + `home/edit-doctor-template`, values);
};

export const searchMedicinesDetailsApi = values => {
  //return axios.post(API_BASE_URL + `doctor/searchMedicinesDetails`, values, getHeader()); //depricated
  return axios.get(API_BASE_URL + `v1/medications`, {
    ...getHeader(),
    params: values
  })
};

export const searchMedicalTestApi = values => {
  return axios.post(API_BASE_URL + `doctor/searchMedicalTest`, values, getHeader());
};

export const getDoctorAllTemplateApi = values => {
  return axios.post(API_BASE_URL + `doctor/getDoctorAllTemplate`, values, getHeader());
};

export const addPrescriptionContentApi = values => {
  return axios.post(API_BASE_URL + `doctor/addPrescriptionContent`, values, getHeader());
};

export const fetchPrescriptionContentApi = values => {
  return axios.post(API_BASE_URL + `doctor/fetchPrescriptionContent`, values, getHeader());
};

export const deletePrescriptionApi = values => {
  return axios.post(API_BASE_URL + `doctor/deletePrescription`, values, getHeader());
};

export const addOtherDoctorTemplateApi = values => {
  return axios.post(API_BASE_URL + `doctor/AddOtherDoctorTemplate`, values, getHeader());
};

export const editOtherDoctorTemplateApi = values => {
  return axios.post(API_BASE_URL + `doctor/EditOtherDoctorTemplate`, values, getHeader());
};

export const getOtherDoctorTemplateApi = values => {
  return axios.post(API_BASE_URL + `doctor/getOtherDoctorTemplate`, values, getHeader());
};

export const addNewDoctorTemplateApi = values => {
  return axios.post(API_BASE_URL + `doctor/AddNewDoctorTemplate`, values, getHeader());
};

export const editNewDoctorTemplateApi = values => {
  return axios.post(API_BASE_URL + `doctor/EditNewDoctorTemplate`, values, getHeader());
};

export const downloadDoctorTemplateApi = values => {
  return axios.post(API_BASE_URL + `doctor/DownloadDoctorTemplate`, values, getHeader());
};

export const getAdminAllTemplateApi = values => {
  return axios.post(API_BASE_URL + `doctor/getAdminAllTemplate`, values, getHeader());
};

export const updateTemplateOrdersApi = values => {
  return axios.post(API_BASE_URL + `doctor/UpdateTemplateOrders`, values, getHeader());
};

export const deleteDoctorNewTemplateApi = values => {
  return axios.post(API_BASE_URL + `doctor/DeleteDoctorNewTemplate`, values, getHeader());
};

export const uploadTemplateAssetApi = values => {
  return axios.post(API_BASE_URL + `doctor/upload-template-asset`, values, getHeader());
};

export const fetchMedicineApi = values => {
  return axios.post(API_BASE_URL + `doctor/fetch-medicine`, values, getHeader());
};
export const fetchMedicineeApi = values => {
  return axios.post(API_BASE_URL + `doctor/fetch-medicinee`, values, getHeader());
};

export const addMedicineApi = values => {
  return axios.post(API_BASE_URL + `doctor/add-medicine`, values, getHeader());
};

export const updateMedicineApi = values => {
  return axios.post(API_BASE_URL + `doctor/update-medicine`, values, getHeader());
};

export const deleteMedicineApi = values => {
  return axios.post(API_BASE_URL + `doctor/delete-medicine`, values, getHeader());
};

// Medical Test Categories APIs
export const getMedicalTestCategoriesApi = (params = {}) => {
  const queryString = new URLSearchParams(
    Object.entries(params).reduce((acc, [key, value]) => {
      if (value !== '' && value !== null && value !== undefined) {
        acc[key] = value;
      }
      return acc;
    }, {})
  ).toString();

  const url = queryString
    ? `${API_BASE_URL}doctor/medical-test-categories?${queryString}`
    : `${API_BASE_URL}doctor/medical-test-categories`;

  return axios.get(url, getHeader());
};

export const getMedicalTestCategoriesWithCountsApi = () => {
  return axios.get(API_BASE_URL + `doctor/medical-test-categories/with-counts`, getHeader());
};

export const getAllCategoriesWithTestsApi = (params = {}, options = {}) => {
  const queryString = new URLSearchParams(
    Object.entries(params || {}).reduce((acc, [key, value]) => {
      if (value !== '' && value !== null && value !== undefined) {
        acc[key] = value;
      }
      return acc;
    }, {})
  ).toString();

  const url = queryString
    ? `${API_BASE_URL}doctor/medical-test-categories/all-with-tests?${queryString}`
    : `${API_BASE_URL}doctor/medical-test-categories/all-with-tests`;

  return axios.get(url, {
    ...getHeader(),
    ...options,
  });
};

export const getSingleCategoryApi = (id) => {
  return axios.get(API_BASE_URL + `doctor/medical-test-categories/${id}`, getHeader());
};

export const createCategoryApi = (values) => {
  return axios.post(API_BASE_URL + `doctor/medical-test-categories`, values, getHeader());
};

export const updateCategoryApi = (id, values) => {
  return axios.put(API_BASE_URL + `doctor/medical-test-categories/${id}`, values, getHeader());
};

export const deleteCategoryApi = (id) => {
  return axios.delete(API_BASE_URL + `doctor/medical-test-categories/${id}`, getHeader());
};

// Medical Tests APIs
export const getMedicalTestsApi = (params = {}) => {
  const queryString = new URLSearchParams(
    Object.entries(params).reduce((acc, [key, value]) => {
      if (value !== '' && value !== null && value !== undefined) {
        acc[key] = value;
      }
      return acc;
    }, {})
  ).toString();

  const url = queryString
    ? `${API_BASE_URL}doctor/medical-tests?${queryString}`
    : `${API_BASE_URL}doctor/medical-tests`;

  return axios.get(url, getHeader());
};

export const getSingleMedicalTestApi = (id) => {
  return axios.get(API_BASE_URL + `doctor/medical-tests/${id}`, getHeader());
};

export const createMedicalTestApi = (values) => {
  return axios.post(API_BASE_URL + `doctor/medical-tests`, values, getHeader());
};

export const updateMedicalTestApi = (id, values) => {
  return axios.put(API_BASE_URL + `doctor/medical-tests/${id}`, values, getHeader());
};

export const deleteMedicalTestApi = (id) => {
  return axios.delete(API_BASE_URL + `doctor/medical-tests/${id}`, getHeader());
};

export const getTestsByCategoryApi = (categoryId) => {
  return axios.get(API_BASE_URL + `doctor/medical-tests/category/${categoryId}`, getHeader());
};

// Medical Test Selections APIs (Saved Test Groups)
export const getMedicalTestSelectionsApi = (params = {}) => {
  const queryString = new URLSearchParams(
    Object.entries(params).reduce((acc, [key, value]) => {
      if (value !== '' && value !== null && value !== undefined) {
        acc[key] = value;
      }
      return acc;
    }, {})
  ).toString();

  const url = queryString
    ? `${API_BASE_URL}doctor/medical-test-selections?${queryString}`
    : `${API_BASE_URL}doctor/medical-test-selections`;

  return axios.get(url, getHeader());
};

export const getSingleMedicalTestSelectionApi = (id) => {
  return axios.get(API_BASE_URL + `doctor/medical-test-selections/${id}`, getHeader());
};

export const createMedicalTestSelectionApi = (values) => {
  return axios.post(API_BASE_URL + `doctor/medical-test-selections`, values, getHeader());
};

export const updateMedicalTestSelectionApi = (id, values) => {
  return axios.put(API_BASE_URL + `doctor/medical-test-selections/${id}`, values, getHeader());
};

export const deleteMedicalTestSelectionApi = (id) => {
  return axios.delete(API_BASE_URL + `doctor/medical-test-selections/${id}`, getHeader());
};

// Payment APIs (new system)
export const createPaymentCheckoutApi = (values) => {
  return axios.post(API_BASE_URL + `v1/payment/checkout`, values, getHeader());
};

export const getPaymentHistoryApi = () => {
  return axios.get(API_BASE_URL + `v1/payment/history`, getHeader());
};

// New Subscription APIs
export const getSubscriptionPlansApi = async () => {
  return axios.get(API_BASE_URL + `doctor/subscription/plans`, getHeader());
};

export const getSubscriptionCurrentApi = async () => {
  return axios.get(API_BASE_URL + `doctor/subscription/current`, getHeader());
};

export const createSubscriptionCheckoutApi = async (values) => {
  return axios.post(API_BASE_URL + `doctor/subscription/checkout`, values, getHeader());
};

export const getSubscriptionHistoryApi = async () => {
  return axios.get(API_BASE_URL + `doctor/subscription/history`, getHeader());
};

// Legacy Subscription APIs (keeping for backward compatibility)
export const getSubscriptionInfoApi = () => {
  return axios.get(API_BASE_URL + `v1/subscription/info`, getHeader());
};

export const createSubscriptionPaymentApi = (values) => {
  return axios.post(API_BASE_URL + `v1/subscription/pay`, values, getHeader());
};

export const addTestsToSelectionApi = (id, testIds) => {
  return axios.post(API_BASE_URL + `doctor/medical-test-selections/${id}/add-tests`, { test_ids: testIds }, getHeader());
};

export const removeTestsFromSelectionApi = (id, testIds) => {
  return axios.post(API_BASE_URL + `doctor/medical-test-selections/${id}/remove-tests`, { test_ids: testIds }, getHeader());
};

// Legacy APIs (keeping for backward compatibility)
export const fetchTestApi = values => {
  return axios.post(API_BASE_URL + `doctor/fetch-test`, values, getHeader());
};

export const addTestApi = values => {
  return axios.post(API_BASE_URL + `doctor/add-test`, values, getHeader());
};

export const updateTestApi = values => {
  return axios.post(API_BASE_URL + `doctor/update-test`, values, getHeader());
};

export const deleteTestApi = values => {
  return axios.post(API_BASE_URL + `doctor/delete-test`, values, getHeader());
};

export const fetchConfigMedicationApi = values => {
  return axios.get(API_BASE_URL + `doctor/fetch-config-medication`, {
    params: values,
    ...getHeader()
  });
};

export const addConfigMedicationApi = values => {
  return axios.post(API_BASE_URL + `doctor/add-config-medication`, values, getHeader());
};

export const deleteConfigMedicationApi = values => {
  return axios.post(API_BASE_URL + `doctor/delete-config-medication`, values, getHeader());
};

export const fetchProtocolApi = (params = {}) => {
  return axios.get(API_BASE_URL + `v1/prescriptor/prescription-templates`, {
    ...getHeader(),
    params
  });
};

export const searchProtocolTemplatesByNameApi = (name, params = {}) => {
  return axios.get(API_BASE_URL + `v1/prescriptor/prescription-templates/search`, {
    ...getHeader(),
    params: {
      name,
      ...params
    }
  });
};

export const addProtocolApi = values => {
  return axios.post(API_BASE_URL + `v1/prescriptor/prescription-templates`, values, getHeader());
};

export const updateProtocolApi = (protocolId, values) => {
  return axios.put(API_BASE_URL + `v1/prescriptor/prescription-templates/${protocolId}`, values, getHeader());
};

export const deleteProtocolApi = protocolId => {
  return axios.delete(API_BASE_URL + `v1/prescriptor/prescription-templates/${protocolId}`, getHeader());
};

// Special Prescription Templates APIs
export const fetchPrescriptionSpecialTemplatesApi = () => {
  return axios.get(API_BASE_URL + `prescription-special-templates`, getHeader());
};

export const addPrescriptionSpecialTemplateApi = values => {
  return axios.post(API_BASE_URL + `prescription-special-templates/store`, values, getHeader());
};

export const updatePrescriptionSpecialTemplateApi = values => {
  return axios.post(API_BASE_URL + `prescription-special-templates/update`, values, getHeader());
};

export const deletePrescriptionSpecialTemplateApi = values => {
  return axios.post(API_BASE_URL + `prescription-special-templates/delete`, values, getHeader());
};

export const updatePrescriptionSpecialTemplateOrderApi = values => {
  return axios.post(API_BASE_URL + `prescription-special-templates/update-order`, values, getHeader());
};

// Admin Special Templates APIs
export const fetchAdminSpecialTemplatesApi = () => {
  return axios.get(API_BASE_URL + `admin/prescription-special-templates`, getHeader());
};

export const addAdminSpecialTemplateApi = values => {
  return axios.post(API_BASE_URL + `admin/prescription-special-templates/store`, values, getHeader());
};

export const updateAdminSpecialTemplateApi = values => {
  return axios.post(API_BASE_URL + `admin/prescription-special-templates/update`, values, getHeader());
};

export const deleteAdminSpecialTemplateApi = values => {
  return axios.post(API_BASE_URL + `admin/prescription-special-templates/delete`, values, getHeader());
};

export const copySpecialTemplateToDoctorApi = (templateId, doctorId) => {
  return axios.post(API_BASE_URL + `admin/prescription-special-templates/${templateId}/copy`, { doctor_id: doctorId }, getHeader());
};

export const downloadSpecialTemplateApi = (templateId) => {
  return axios.post(API_BASE_URL + `prescription-special-templates/${templateId}/download`, {}, getHeader());
};

export const printDocumentTemplateApi = values => {
  return axios.post(API_BASE_URL + `doctor/printDocumentTemplate`, values, getHeader());
};

// Prescriptor v1 API (new prescription workflow)
export const createPrescriptorPrescriptionApi = (values) => {
  return axios.post(API_BASE_URL + `v1/prescriptor/prescriptions`, values, getHeader());
};

export const createPrescriptorPrescriptionFromTemplateApi = (values) => {
  return axios.post(API_BASE_URL + `v1/prescriptor/prescriptions/from-template`, values, getHeader());
};

export const listPrescriptorPrescriptionTemplatesApi = (params = {}) => {
  return axios.get(API_BASE_URL + `v1/prescriptor/prescription-templates`, {
    ...getHeader(),
    params
  });
};

export const searchPrescriptorPrescriptionTemplatesByNameApi = (name, params = {}) => {
  return axios.get(API_BASE_URL + `v1/prescriptor/prescription-templates/search`, {
    ...getHeader(),
    params: {
      name,
      ...params
    }
  });
};

export const updatePrescriptorPrescriptionApi = (prescriptionId, values) => {
  return axios.put(API_BASE_URL + `v1/prescriptor/prescriptions/${prescriptionId}`, values, getHeader());
};

export const updatePrescriptorPrescriptionPatientDataApi = (prescriptionId, values) => {
  return axios.patch(API_BASE_URL + `v1/prescriptor/prescriptions/${prescriptionId}/patient-data`, values, getHeader());
};

export const deletePrescriptorPrescriptionApi = (prescriptionId) => {
  return axios.delete(API_BASE_URL + `v1/prescriptor/prescriptions/${prescriptionId}`, getHeader());
};

export const createPrescriptorPrescriptionEntryApi = (prescriptionId, values) => {
  return axios.post(API_BASE_URL + `v1/prescriptor/prescriptions/${prescriptionId}/entries`, values, getHeader());
};

export const updatePrescriptorPrescriptionEntryApi = (prescriptionId, entryId, values) => {
  return axios.put(API_BASE_URL + `v1/prescriptor/prescriptions/${prescriptionId}/entries/${entryId}`, values, getHeader());
};

export const deletePrescriptorPrescriptionEntryApi = (prescriptionId, entryId) => {
  return axios.delete(API_BASE_URL + `v1/prescriptor/prescriptions/${prescriptionId}/entries/${entryId}`, getHeader());
};

export const listPrescriptorPrescriptionsByAppointmentApi = (appointmentId, params = {}) => {
  return axios.get(API_BASE_URL + `v1/prescriptor/appointments/${appointmentId}/prescriptions`, {
    ...getHeader(),
    params
  });
};

export const showPrescriptorPrescriptionApi = (prescriptionId) => {
  return axios.get(API_BASE_URL + `v1/prescriptor/prescriptions/${prescriptionId}`, getHeader());
};

export const printPrescriptorDocumentTemplateApi = (values) => {
  return axios.post(API_BASE_URL + `v1/prescriptor/print/document-template`, values, getHeader());
};

export const generatePrescriptionV7PdfApi = (values) => {
  return axios.post(API_BASE_URL + `prescriptions/v7/generate-pdf`, values, {
    ...getHeader(),
    responseType: 'blob'
  });
};

export const updateDoctorTempDetailsApi = values => {
  return axios.post(API_BASE_URL + `doctor/updateDoctorTempDetails`, values, getHeader());
};

export const fetchAllMedicalCategoryApi = (values) => {
  return axios.get(
    API_BASE_URL + `doctor/fetchAllMedicalCategory`,
    {
      ...getHeader(),
      params: values
    }
  );
};
export const fetchLastScansApi = (doctorId) => {
  return axios.get(
    `${API_BASE_URL}doctor/${doctorId}/last-scans`,
    getHeader()
  );
};

export const markScansAsSeenApi = (doctorId, scanIds) => {
  return axios.post(
    `${API_BASE_URL}doctor/${doctorId}/mark-scans-seen`,
    { scan_ids: scanIds },
    getHeader()
  );
};

export const addMedicalBackgroundApi = values => {
  return axios.post(API_BASE_URL + `doctor/add-medical`, values, getHeader());
};

export const deleteMedicalBackgroundApi = values => {
  return axios.post(API_BASE_URL + `doctor/delete-medical`, values, getHeader());
};

export const addObservationApi = values => {
  return axios.post(API_BASE_URL + `doctor/AddObservation`, values, getHeader());
};

export const getIndicatorCategoryApi = values => {
  return axios.post(API_BASE_URL + `doctor/getIndicatorCategory`, values, getHeader());
};

export const AddIndicatorApi = values => {
  return axios.post(API_BASE_URL + `doctor/AddIndicator`, values, getHeader());
};

export const getIndicatorApi = values => {
  return axios.post(API_BASE_URL + `doctor/getIndicator`, values, getHeader());
};

export const deleteIndicatorApi = values => {
  return axios.post(API_BASE_URL + `doctor/deleteIndicator`, values, getHeader());
};

export const medicalObservationListApi = values => {
  return axios.post(API_BASE_URL + `doctor/medicalObservationList`, values, getHeader());
};

export const addPaymentApi = values => {
  return axios.post(API_BASE_URL + `doctor/addPayment`, values, getHeader());
};

export const getPaymentApi = values => {
  return axios.post(API_BASE_URL + `doctor/getPayment`, values, getHeader());
};

export const nurseLoginApi = values => {
  return axios.post(API_BASE_URL + `doctor/nurseLogin`, values);
};

export const searchPatientApi = values => {
  return axios.post(API_BASE_URL + `doctor/searchPatient`, values, getHeader());
};
export const getDoctorPatientsApi = (doctorId, params = {}) => {
  const queryString = new URLSearchParams(
    Object.entries(params).reduce((acc, [key, value]) => {
      if (value !== '' && value !== null && value !== undefined) {
        acc[key] = value;
      }
      return acc;
    }, {})
  ).toString();

  const url = queryString
    ? `${API_BASE_URL}doctors/${doctorId}/patients/search?${queryString}`
    : null;
  return url ? axios.get(url, getHeader()) : [];
};

export const createAppointmentByDoctorApi = values => {
  return axios.post(API_BASE_URL + `doctor/createAppointmentByDoctor`, values, getHeader());
};

export const getPatientDictionaryDetailsApi = values => {
  return axios.post(API_BASE_URL + `doctor/getPatientDictionaryDetails`, values, getHeader());
};

export const createGlobalNoteApi = values => {
  return axios.post(API_BASE_URL + `doctor/createGlobalNote`, values, getHeader());
};

export const createDictionaryNoteApi = values => {
  return axios.post(API_BASE_URL + `doctor/createDictionaryNote`, values, getHeader());
};

export const patientFamilyListApi = values => {
  return axios.post(API_BASE_URL + `doctor/patientFamilyList`, values, getHeader());
};

export const fetchDoctorDictionaryMessageDetailsApi = values => {
  return axios.post(API_BASE_URL + `doctor/fetchDoctorDictionaryMessageDetails`, values, getHeader());
};

export const printReferDocumentTemplateApi = values => {
  return axios.post(API_BASE_URL + `doctor/printReferDocumentTemplate`, values, getHeader());
};

export const checkIdPhonenumberApi = values => {
  return axios.post(API_BASE_URL + `patient/checkIdPhonenumber`, values);
};

export const createPasswordApi = values => {
  return axios.post(API_BASE_URL + `patient/createPassword`, values);
};

export const getDoctorListByPatintApi = values => {
  return axios.post(API_BASE_URL + `patient/getDoctorListByPatint`, values);
};

export const searchPatientByAllFieldApi = values => {
  return axios.post(API_BASE_URL + `doctor/searchPatientByAllField`, values, getHeader());
};

export const patientVisitStatusApi = values => {
  return axios.post(API_BASE_URL + `doctor/patientVisitStatus`, values, getHeader());
};

export const updatePatientFromDoctorByPatientIdApi = values => {
  return axios.post(API_BASE_URL + `doctor/updatePatientFromDoctorByPatientId`, values, getHeader());
};

export const verifyPrescriptionUniqueCodeApi = values => {
  return axios.post(API_BASE_URL + `doctor/verifyPrescriptionUniqueCode`, values);
};

export const doctorAddPatientMemberApi = values => {
  return axios.post(API_BASE_URL + `doctor/add-member`, values, getHeader());
};

export const doctorEditPhoneNumberApi = values => {
  return axios.post(API_BASE_URL + `doctor/editPhoneNumber`, values, getHeader());
};

export const choseChildApi = values => {
  return axios.post(API_BASE_URL + `doctor/choseChild`, values, getHeader());
};

export const addFavoritDoctorApi = values => {
  return axios.post(API_BASE_URL + `patient/addFavoritDoctor`, values, getHeader());
};

export const getFavoritDoctorApi = values => {
  return axios.post(API_BASE_URL + `patient/getFavoritDoctor`, values, getHeader());
};

export const deleteFavoritDoctorApi = values => {
  return axios.post(API_BASE_URL + `patient/deleteFavoritDoctor`, values, getHeader());
};

export const addReviewApi = values => {
  return axios.post(API_BASE_URL + `patient/addReview`, values, getHeader());
};

export const fetchNotificationApi = () => {
  return axios.get(API_BASE_URL + `patient/fetch-notification`, getHeader());
};

export const confirmAppointmentApi = values => {
  return axios.post(API_BASE_URL + `patient/confirm-appointment`, values, getHeader());
};

export const deleteNotificationApi = values => {
  return axios.post(API_BASE_URL + `patient/delete-notification`, values, getHeader());
};

export const searchLocationApi = values => {
  return axios.post(API_BASE_URL + `home/get-city-state`, values);
};

export const cmsDataApi = values => {
  return axios.post(API_BASE_URL + `home/cms`, values);
};

export const helpCenterApi = values => {
  return axios.post(API_BASE_URL + `home/help-center`, values);
};

export const getHelpCenterSettingsApi = () => {
  return axios.get(API_BASE_URL + `home/get-help-center-settings`);
};

export const patientCancelAppointmentApi = values => {
  return axios.post(API_BASE_URL + `patient/cancel-appointment`, values, getHeader());
};

export const patientRescheduleAppointmentApi = values => {
  return axios.post(API_BASE_URL + `patient/reschedule-appointment`, values, getHeader());
};

export const updateSlotApi = values => {
  return axios.post(API_BASE_URL + `doctor/update-slot`, values, getHeader());
};

export const getDiagnosticTitlesApi = () => {
  return axios.get(API_BASE_URL + `doctor/doctor/diagnostics/titles`, getHeader());
};
export const listDiagnosticsApi = (doctorId) =>
  axios.get(`${API_BASE_URL}doctor/${doctorId}/config/diagnostics`, getHeader());

export const saveDiagnosticApi = (doctorId, payload /* {id?, nom} */) =>
  axios.post(`${API_BASE_URL}doctor/${doctorId}/config/diagnostics/save`, payload, getHeader());

export const deleteDiagnosticApi = (doctorId, id) =>
  axios.delete(`${API_BASE_URL}doctor/${doctorId}/config/diagnostics/${id}`, getHeader());
// ---- EXAMINATIONS ----
export const getDoctorExaminationsApi = () => {
  return axios.get(API_BASE_URL + `doctor/observs`, getHeader());
};
// --- DOCS RAIL ---
// Liste des docs (filtrable par doctor_id / patient_id / appointment_id)
export const fetchDocsApi = (values) => {
  // values = { doctor_id, patient_id, appointment_id }
  return axios.post(API_BASE_URL + `doctor/doctor/prescriptions`, values, getHeader());
};

// Fetch all doctor documents with signed URLs
// doctorId: number - The unique identifier of the doctor
// appointmentId: number (optional) - Filter by appointment ID
// Returns: Promise with signed URLs valid for 60 minutes
export const fetchDocsWithSignedUrlsApi = (doctorId, appointmentId) => {
  console.log(`fetching for appointmentId=${appointmentId ? appointmentId : "ALL"}`);
  const params = appointmentId ? { appointment_id: appointmentId } : {};
  return axios.get(API_BASE_URL + `doctor/doctor/${doctorId}/docs/signed-urls`, {
    ...getHeader(),
    params
  });
};

// Upload doc (image/pdf/docx) – accepte FormData
//   form: { file, doctor_id, patient_id, [appointment_id], [name] }
//   onProgress: (0..100) => void (optionnel)
export const uploadDocApi = (form, onProgress) => {
  return axios.post(API_BASE_URL + `doctor/doctor/docs/upload`, form, {
    ...getHeader(),
    headers: {
      ...getHeader().headers,
      "Content-Type": "multipart/form-data"
    },
    onUploadProgress: (p) => {
      if (onProgress && p.total) {
        onProgress(Math.round((p.loaded * 100) / p.total));
      }
    },
  });
};

// Delete doc
export const deleteDocApi = (values) => {
  // values = { id }
  return axios.post(API_BASE_URL + `doctor/doctor/docs/delete`, values, getHeader());
};

// Tout (catégorie + item)
export const listObservsApi = () => {
  return axios.get(`${API_BASE_URL}doctor/observs/`, getHeader());
};

// Items d’une catégorie
export const listObservItemsByCategoryApi = (categorie) => {
  // IMPORTANT: encoder la catégorie si elle contient des espaces/accents
  const enc = encodeURIComponent(categorie);
  return axios.get(`${API_BASE_URL}doctor/observs/categories/${enc}/items`, getHeader());
};
export const fetchAntecedentTitles = async () => {
  const url = `${API_BASE_URL}doctor/doctor/antecedents`;
  const { data } = await axios.get(url, getHeader());
  // sécurise le retour
  return Array.isArray(data?.data) ? data.data : [];
};





export const searchStyles = async (q) => {
  const { data } = await axios.get(
    `${API_BASE_URL}doctor/styles`,
    { params: { q }, ...getHeader() }
  );
  // attendu: { res:true, data:[ {id, categorie, item}, ... ] }
  return Array.isArray(data?.data) ? data.data : [];
};

export const fetchStyleItemsByCategory = async (categorie) => {
  const { data } = await axios.get(
    `${API_BASE_URL}doctor/styles/categories/${encodeURIComponent(categorie)}/items`,
    getHeader()
  );
  // attendu: { res:true, data:[ {id, categorie, item}, ... ] } OU juste [items...]
  const arr = Array.isArray(data?.data) ? data.data : [];
  // normalise au même format {id?, categorie, item}
  return arr.map(x => (
    typeof x === "string"
      ? { id: null, categorie, item: x }
      : { id: x?.id ?? null, categorie: x?.categorie ?? categorie, item: x?.item ?? String(x ?? "") }
  ));
};
// services/doctor.js (ou équivalent)
export const fetchAllAllergens = async () => {
  const { data } = await axios.get(`${API_BASE_URL}doctor/allergens`, getHeader());
  // attendu: data.data = [{ id, categorie, allergene }, ...]
  return Array.isArray(data?.data) ? data.data : [];
};


export const fetchAllergensByGroup = async (groupe) => {
  const encoded = encodeURIComponent(groupe ?? "");
  const url = `${API_BASE_URL}doctor/allergens/${encoded}/items`;
  const { data } = await axios.get(url, getHeader());
  return Array.isArray(data?.data) ? data.data : [];
};

export const listAllergieConfigsApi = async (doctorId) => {
  const { data } = await axios.get(`${API_BASE_URL}doctor/${doctorId}/config/allergies`, getHeader());
  return Array.isArray(data?.data) ? data.data : [];
};

export const saveAllergieConfigApi = async (doctorId, payload) => {
  // payload: { id?, categorie, item }
  const { data } = await axios.post(`${API_BASE_URL}doctor/${doctorId}/config/allergies/save`, payload, getHeader());
  return data?.data || data;
};

export const deleteAllergieConfigApi = async (doctorId, id) => {
  return axios.delete(`${API_BASE_URL}doctor/${doctorId}/config/allergies/${id}`, getHeader());
};

export const fetchProtocolCategories = async () => {
  const url = `${API_BASE_URL}doctor/protocols`;
  const { data } = await axios.get(url, getHeader());
  const rows = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);
  const cats = [...new Set(rows.map(r => String(r.categorie || "").trim()).filter(Boolean))];
  return cats.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));
};

/**
 * Récupère les examens d'une catégorie (backend renvoie un tableau de strings).
 * On normalise en objets {id,label,prix} ;
 * - id = `${categorie}:${index}`
 * - label = nom de l'examen (string)
 * - prix = "" (inconnu côté backend pour l’instant)
 *
 * @param {string} categorie
 * @param {string} q (optionnel) => filtrage côté front (le backend ne gère pas ?q=)
 */
export const fetchProtocolExamsByCategory = async (categorie, q) => {
  const cat = encodeURIComponent(categorie ?? "");
  const url = `${API_BASE_URL}doctor/protocols/categories/${cat}/exams`;
  const { data } = await axios.get(url, getHeader());

  const list = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);
  const filtered = q ? list.filter(name =>
    String(name).toLowerCase().includes(String(q).toLowerCase())
  ) : list;

  return filtered.map((name, idx) => ({
    id: `${categorie}:${idx}`,
    label: String(name),
    prix: "", // pas de prix dans ton backend → on laisse vide
  }));
};

export const fetchTreatmentsList = async () => {
  const url = `${API_BASE_URL}doctor/treatments`;
  const { data } = await axios.get(url, getHeader());

  const list = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);
  // normalisation + on ne garde que l’item (liste plate unique)
  const items = list
    .map(r => (r?.item ?? "").trim())
    .filter(Boolean);

  // dédoublonnage en conservant l’ordre
  const unique = Array.from(new Set(items));
  return unique; // ex: ["Amoxicilline","Warfarine", ...]
};

export const fetchChartsList = async () => {
  const url = `${API_BASE_URL}doctor/charts`;
  const { data } = await axios.get(url, getHeader());
  const list = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);
  // normalise
  return list.map((r) => ({
    id: r.id,
    parametre: r.parametre ?? "",
    unite: r.unite ?? "",
    valeur_min: r.valeur_min ?? "",
    valeur_max: r.valeur_max ?? "",
    frequence_typique: r.frequence_typique ?? "",
  }));
};

/** Détail par paramètre (accents/espaces OK) */
export const fetchChartByParam = async (parametre) => {
  const p = encodeURIComponent(parametre ?? "");
  const url = `${API_BASE_URL}doctor/charts/${p}`;
  const { data } = await axios.get(url, getHeader());
  if (data?.res !== true || !data?.data) return null;
  const r = data.data;
  return {
    id: r.id,
    parametre: r.parametre ?? "",
    unite: r.unite ?? "",
    valeur_min: r.valeur_min ?? "",
    valeur_max: r.valeur_max ?? "",
    frequence_typique: r.frequence_typique ?? "",
  };
};


// ✅ Service (OK chez toi — je le laisse identique)
const mapServerService = (r) => ({
  id: r.id ?? r.service_config_id ?? r.serviceId ?? null,
  name: (r.nom ?? r.name ?? "").toString().trim(),
  color: (r.couleur ?? r.color ?? r.colour ?? r.hex ?? r.bg ?? r.background ?? null), // ★ important
  price: Number(r.prix ?? r.price ?? 0),
  type: r.type ?? "",
  usable: !!(r.is_utilisable ?? r.usable),
  archived: !!(r.is_archiver ?? r.is_archived ?? r.archived),
  qty: Number(r.qte ?? r.qty ?? 0),
});

export const fetchDoctorServices = async (doctorId) => {
  const url = `${API_BASE_URL}doctor/${doctorId}/services`;
  const { data } = await axios.get(url, getHeader());
  const list = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);
  return (list || []).map(mapServerService);
};
// apiService.jsx (ou équivalent)
// apiService.jsx (ou équivalent)
// API client: accepte amount = 0 et propage appointment_id
// API client
export async function addDebtImputationApi(doctorId, payload) {
  if (!doctorId) throw new Error("doctorId manquant");
  if (!payload || typeof payload !== "object") throw new Error("payload invalide");

  const amt =
    payload.amount == null || String(payload.amount).trim() === ""
      ? 0
      : Number(String(payload.amount).replace(",", "."));
  if (!Number.isFinite(amt) || amt < 0) throw new Error("amount invalide");
  if (!payload.patient_id) throw new Error("patient_id manquant");

  const body = {
    patient_id: Number(payload.patient_id),
    amount: amt,
    day_key: String(payload.day_key || new Date().toISOString().slice(0, 10)).slice(0, 10),
    note: payload.note ?? undefined,
    remark: payload.remark ?? undefined,
    created_at: payload.created_at ?? undefined,

    // ⬅️ RDV (optionnel mais prioritaire si fourni)
    appointment_id:
      payload.appointment_id != null
        ? Number(payload.appointment_id)
        : undefined,

    // ⬅️ Mode explicite + compat "as_delta"
    mode: payload.mode === "delta" ? "delta" : (payload.mode === "set" ? "set" : undefined),
    as_delta: payload.mode === "delta" ? 1 : 0,
  };

  const res = await fetch(`${API_BASE_URL}doctor/${doctorId}/payments/impute-debt`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try {
      const err = await res.json();
      if (err?.message) msg += ` - ${err.message}`;
      if (err?.errors) msg += ` - ${JSON.stringify(err.errors)}`;
    } catch { }
    throw new Error(`Échec imputation: ${msg}`);
  }

  const j = await res.json();
  if (!j?.success) throw new Error(`Échec imputation: ${j?.message || "imputation failed"}`);
  return j.data;
}







// Base URL robuste (retire le slash final si présent)
const apiBase = () => API_BASE_URL.replace(/\/$/, "");
export const doctorBase = (doctorId) => `${apiBase()}/doctors/${doctorId}`;

// Segments de route
const ETAPES_ENDPOINT = "timeline-etapes";
const CARDS_ENDPOINT = "timline-cards";      // ← orthographe exacte de tes routes
const TPL_ENDPOINT = "timeline-templates";

// Utils
const toHex6 = (c) => {
  const v = String(c || "").trim();
  return /^#[0-9A-Fa-f]{6}$/.test(v) ? v.toUpperCase() : "#A0AEC0";
};
export const OBS_ENDPOINT = "timeline-observations";


export const mapServerObservation = (x = {}) => {
  const evDate = String(x.event_date ?? x.date ?? "").slice(0, 10) || null;
  return {
    id: Number(x.id),
    doctor_id: Number(x.doctor_id ?? 0),
    patient_id: Number(x.patient_id ?? 0),
    type: String(x.type ?? "note"),
    title: String(x.titre ?? "").trim(),
    description: x.description ?? null,
    image: x.image ?? null,
    image_url: x.image_url ?? null,
    event_date: evDate,
    date: evDate,
    year: evDate ? evDate.slice(0, 4) : null,
    color: x.color ? String(x.color) : "#A0AEC0",
  };
};

export const fetchTimelineObservations = async (doctorId, params = {}) => {
  const query = new URLSearchParams(params).toString();
  const url = `${doctorBase(doctorId)}/${OBS_ENDPOINT}${query ? `?${query}` : ""}`;
  const { data } = await axios.get(url, getHeader());
  const list = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);
  const meta = data?.meta ?? null;
  return { items: list.map(mapServerObservation), meta };
};


export const showTimelineObservation = async (doctorId, id) => {
  const url = `${doctorBase(doctorId)}/${OBS_ENDPOINT}/${id}`;
  const { data } = await axios.get(url, getHeader());
  return mapServerObservation(data?.data ?? data);
};


export const createTimelineObservation = async (doctorId, payload = {}) => {
  console.log("createTimelineObservation payload:", payload);
  const url = `${doctorBase(doctorId)}/${OBS_ENDPOINT}`;

  if (payload?.image_file instanceof File) {
    const fd = new FormData();
    fd.append("patient_id", String(payload.patient_id));
    fd.append("titre", String(payload.titre || "").trim());
    if (payload.description != null) fd.append("description", String(payload.description));
    if (payload.type) fd.append("type", String(payload.type));
    if (payload.date) fd.append("date", String(payload.date));       // ← important
    if (payload.color) fd.append("color", String(payload.color));    // ← important
    fd.append("image_file", payload.image_file);
    const { data } = await axios.post(url, fd, {
      ...getHeader(),
      headers: { ...(getHeader()?.headers || {}), "Content-Type": "multipart/form-data" },
    });
    return mapServerObservation(data?.data ?? data);
  }

  const body = {
    patient_id: Number(payload.patient_id),
    titre: String(payload.titre || "").trim(),
    description: payload.description ?? null,
    type: payload.type || "note",
    image: payload.image ?? null,
    date: payload.date ?? null,      // ← map vers event_date côté back
    color: payload.color ?? null,
  };
  const { data } = await axios.post(url, body, getHeader());
  return mapServerObservation(data?.data ?? data);
};


export const updateTimelineObservation = async (doctorId, id, payload) => {
  const url = `${doctorBase(doctorId)}/timeline-observations/${id}`;
  if (payload instanceof FormData) {
    const { data } = await axios.post(url, payload, {
      headers: { ...(getHeader()?.headers || {}), Accept: "application/json" },
    });
    return mapServerObservation(data?.data ?? data);
  } else {
    const { data } = await axios.put(url, payload, getHeader());
    return mapServerObservation(data?.data ?? data);
  }
};



/** Delete */
export const deleteTimelineObservation = async (doctorId, id) => {
  const url = `${doctorBase(doctorId)}/${OBS_ENDPOINT}/${id}`;
  const { data } = await axios.delete(url, getHeader());
  return data?.data ?? data ?? { deleted: true };
};

/* ========================= ÉTAPES (timeline-etapes) =========================
   Modèle: { id, nom, couleur } */
const ensureHex6 = (c = "#A0AEC0") => {
  try {
    let s = String(c || "#A0AEC0").trim();
    if (!s) return "#A0AEC0";
    if (!s.startsWith("#")) s = `#${s}`;
    if (s.length === 4) s = `#${s[1]}${s[1]}${s[2]}${s[2]}${s[3]}${s[3]}`;
    return s.toUpperCase();
  } catch {
    return "#A0AEC0";
  }
};

const mapServerEtape = (x = {}) => ({
  id: Number(x.id),
  label: String(x.nom ?? "").trim(),
  color: ensureHex6(x.couleur ?? "#A0AEC0"),
});

export const fetchTimelineEtapes = async (doctorId) => {
  try {
    const url = `${doctorBase(doctorId)}/${ETAPES_ENDPOINT}`;
    const { data } = await axios.get(url, getHeader());
    const list = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);
    return list.map(mapServerEtape);
  } catch (err) {
    console.error("[fetchTimelineEtapes] error:", err);
    return [];
  }
};

export const createTimelineEtape = async (doctorId, { label, color }) => {
  const url = `${doctorBase(doctorId)}/${ETAPES_ENDPOINT}`;
  const nom = (String(label || "").trim()) || "Étape";
  const couleur = toHex6(color);
  const { data } = await axios.post(url, { nom, couleur }, getHeader());
  return mapServerEtape(data?.data ?? data);
};

export const updateTimelineEtape = async (doctorId, id, patch = {}) => {
  const url = `${doctorBase(doctorId)}/${ETAPES_ENDPOINT}/${id}`;
  const body = {};
  if (patch.label !== undefined) {
    const t = String(patch.label).trim();
    if (t) body.nom = t;
  }
  if (patch.color !== undefined) body.couleur = toHex6(patch.color);
  if (Object.keys(body).length === 0) return mapServerEtape({ id, nom: patch.label, couleur: patch.color });

  const { data } = await axios.patch(url, body, getHeader());
  return mapServerEtape(data?.data ?? data);
};
export const deleteTimelineEtape = async (doctorId, id) => {
  const url = `${doctorBase(doctorId)}/${ETAPES_ENDPOINT}/${id}`;
  const { data } = await axios.delete(url, getHeader());
  return !!(data?.data?.deleted ?? true);
};

/* ========================= CARDS (timline-cards) ============================
   Modèle: { id, titre, couleur } */
const mapServerCard = (x = {}) => ({
  id: Number(x.id),
  label: String(x.titre ?? "").trim(),               // ← titre
  color: String(x.couleur ?? "#A0AEC0").toUpperCase(),
});

export const fetchTimelineCards = async (doctorId) => {
  const url = `${doctorBase(doctorId)}/${CARDS_ENDPOINT}`;
  const { data } = await axios.get(url, getHeader());
  const list = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);
  return list.map(mapServerCard);
};

export const createTimelineCard = async (doctorId, { label, color }) => {
  const url = `${doctorBase(doctorId)}/${CARDS_ENDPOINT}`;
  const titre = (String(label || "").trim()) || "Sans titre";
  const couleur = toHex6(color);
  const { data } = await axios.post(url, { titre, couleur }, getHeader());
  return mapServerCard(data?.data ?? data);
};

export const updateTimelineCard = async (doctorId, id, patch = {}) => {
  const url = `${doctorBase(doctorId)}/${CARDS_ENDPOINT}/${id}`;
  const body = {};
  if (patch.label !== undefined || patch.title !== undefined) {
    const t = String((patch.label ?? patch.title) ?? "").trim();
    if (t) body.titre = t;
  }
  if (patch.color !== undefined) body.couleur = toHex6(patch.color);

  if (Object.keys(body).length === 0) return mapServerCard({ id, titre: patch.label ?? patch.title, couleur: patch.color });

  const { data } = await axios.patch(url, body, getHeader());
  return mapServerCard(data?.data ?? data);
};

export const deleteTimelineCard = async (doctorId, id) => {
  const url = `${doctorBase(doctorId)}/${CARDS_ENDPOINT}/${id}`;
  const { data } = await axios.delete(url, getHeader());
  return !!(data?.data?.deleted ?? true);
};

/* ========================= TEMPLATES (timeline-templates) ================== */
// petit helper pour récupérer un entier à partir de plusieurs clés possibles
const pickInt = (...vals) => {
  for (const v of vals) {
    if (v === undefined || v === null || v === '') continue;
    const n = Number(v);
    if (!Number.isNaN(n)) return Math.trunc(n);
  }
  return 0;
};

const mapServerTemplateListItem = (x = {}) => ({
  id: Number(x.id),
  name: String(x.nom_template ?? "").trim(),
  steps_count: Number(x.steps_count ?? 0),
});

const mapServerTemplateDetail = (x = {}) => ({
  id: Number(x.id),
  name: String(x.nom_template ?? "").trim(),
  steps: Array.isArray(x.steps)
    ? x.steps.map((s) => {
      const duree = pickInt(
        s.duree,           // cas simple
        s.duree_jours,     // autre nom courant
        s.nb_jours,        // variante
        s.jours,           // variante
        s.offset_jours,    // variante
        s.delai_jours,     // variante
        s.delai            // au cas où
      );

      return {
        id: Number(s.id),
        etape_id: Number(s.etape_id),
        ordre: Number(s.ordre),
        titre_override: s.titre_override ?? s.nom_override ?? null,
        color_override: s.couleur_override ?? s.color_override ?? null,

        // on expose les deux pour compatibilité
        duree,             // <— à utiliser de préférence
        duree_jours: duree // <— compat avec l’ancien code
      };
    })
    : [],
});

export const fetchTimelineTemplates = async (doctorId) => {
  const url = `${doctorBase(doctorId)}/${TPL_ENDPOINT}`;
  const { data } = await axios.get(url, getHeader());
  const list = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);
  return list.map(mapServerTemplateListItem);
};

export const fetchTimelineTemplate = async (doctorId, templateId) => {
  const url = `${doctorBase(doctorId)}/${TPL_ENDPOINT}/${templateId}`;
  const { data } = await axios.get(url, getHeader());
  return mapServerTemplateDetail(data?.data ?? data);
};

export const createTimelineTemplate = async (doctorId, { name }) => {
  const url = `${doctorBase(doctorId)}/${TPL_ENDPOINT}`;
  const nom_template = String(name || "").trim();
  const { data } = await axios.post(url, { nom_template }, getHeader());
  return { id: Number(data?.data?.id ?? data?.id), name: data?.data?.nom_template ?? nom_template };
};

export const updateTimelineTemplate = async (doctorId, id, { name }) => {
  const url = `${doctorBase(doctorId)}/${TPL_ENDPOINT}/${id}`;
  const nom_template = String(name || "").trim();
  const { data } = await axios.patch(url, { nom_template }, getHeader());
  return { id: Number(data?.data?.id ?? id), name: (data?.data?.nom_template ?? nom_template) };
};

export const deleteTimelineTemplate = async (doctorId, id) => {
  const url = `${doctorBase(doctorId)}/${TPL_ENDPOINT}/${id}`;
  const { data } = await axios.delete(url, getHeader());
  return !!(data?.data?.deleted ?? true);
};

// Remplace toutes les étapes d’un template
// stepsForApi: [{ etape_id:number, ordre:number, titre_override?, couleur_override? }]
export const setTimelineTemplateSteps = async (doctorId, templateId, stepsForApi) => {
  const url = `${doctorBase(doctorId)}/${TPL_ENDPOINT}/${templateId}/steps`;
  const { data } = await axios.put(url, { steps: stepsForApi }, getHeader());
  return mapServerTemplateDetail(data?.data ?? data);
};

// Utilitaire: s’assurer que chaque step (label/color) existe bien comme ÉTAPE
export const ensureEtapesForSteps = async (doctorId, uiSteps /* [{label,color}] */) => {
  const existing = await fetchTimelineEtapes(doctorId);
  const acc = [...existing];

  const result = [];
  for (const s of uiSteps) {
    const lab = String(s.label || "").trim();
    const col = toHex6(s.color);

    let found = acc.find((c) => c.label.toLowerCase() === lab.toLowerCase() && c.color === col);
    if (!found) {
      found = await createTimelineEtape(doctorId, { label: lab || "Étape", color: col });
      acc.push(found);
    }
    result.push(found);
  }
  return result; // [{id,label,color}]
};

// ✅ Protocole (⚠️ c'est ici qu'il faut couvrir "couleur")
// 🔁 ajoute "comment" et "appointment_id" dans le mapper
const mapServerProtocol = (r) => ({
  id: Number(r.id),
  doctor_id: Number(r.doctor_id),
  patient_id: Number(r.patient_id),
  appointment_id: r.appointment_id ? Number(r.appointment_id) : null,
  label: (r.service ?? r.label ?? "").toString(),
  color: (r.color ?? r.couleur ?? null),
  done: !!(r.is_done ?? r.done),
  created_at: r.created_at ?? null,
  comment: (r.comment ?? r.comments ?? r.note ?? r.remark ?? null), // ⬅️ NEW
});
// ⇨ ajoute ça à côté de tes autres appels axios
export const addOrIncUsedApi = async (doctorId, { id_patient, nom, code, qte, stock_config_id, appointment_id }) => {
  const url = `${API_BASE_URL}doctor/${doctorId}/stock-utiliser`;
  const payload = {
    id_patient: Number(id_patient),
    nom: String(nom || code || '').trim(),
    code: String(code || nom || '').trim(),
    qte: Math.max(1, Number(qte || 1)),
    ...(stock_config_id ? { stock_config_id: Number(stock_config_id) } : {}),
    ...(appointment_id !== undefined && appointment_id !== null ? { appointment_id: Number(appointment_id) } : {}),
  };
  const { data } = await axios.post(url, payload, buildAuthHeaders());
  // On suppose que le back renvoie { success:true, data:{ id, id_doctor, id_patient, stock_config_id, nom, code, qte, ... } }
  return data?.data || null;
};

export const listDoctorProtocolsoins = async (doctorId, { patientId, appointmentId } = {}) => {
  const url = `${API_BASE_URL}doctor/${doctorId}/soin/protocols`;
  const params = {
    ...(patientId ? { patient_id: patientId } : {}),
    ...(appointmentId ? { appointment_id: appointmentId } : {}),
  };
  const { data } = await axios.get(url, { ...buildAuthHeaders(), params });
  const list = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);
  return (list || []).map(mapServerProtocol);
};
export const listDoctorProtocolsoinss = async (doctorId, { patientId, appointmentId } = {}) => {
  const url = `${API_BASE_URL}doctor/${doctorId}/soin/protocolss`;
  const params = {
    ...(patientId ? { patient_id: patientId } : {}),
    ...(appointmentId ? { appointment_id: appointmentId } : {}),
  };
  const { data } = await axios.get(url, { ...buildAuthHeaders(), params });
  const list = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);
  return (list || []).map(mapServerProtocol);
};

export const createDoctorProtocolsoin = async (doctorId, payload) => {
  // payload peut contenir: { patient_id, label/service, color, comment, appointment_id, service_id, ... }
  const url = `${API_BASE_URL}doctor/${doctorId}/soin/protocols`;
  // ✅ IMPORTANT: Keep appointment_id and service_id even if null - backend needs them!
  // Only filter out undefined values, NOT null
  const body = Object.fromEntries(Object.entries(payload || {}).filter(([, v]) => typeof v !== 'undefined'));
  console.warn('🔴 createDoctorProtocolsoin sending:', body);
  const { data } = await axios.post(url, body, buildAuthHeaders());
  return mapServerProtocol(data?.data ?? data);
};

export const updateDoctorProtocolsoin = async (doctorId, id, payload) => {
  // payload partiel: { label?, color?, comment?, is_done? }
  const url = `${API_BASE_URL}doctor/${doctorId}/soin/protocols/${id}`;
  const { data } = await axios.patch(url, payload, buildAuthHeaders());
  return mapServerProtocol(data?.data ?? data);
};

export const setDoctorProtocolsoinDone = async (doctorId, id, is_done) => {
  const url = `${API_BASE_URL}doctor/${doctorId}/soin/protocols/${id}/done`;
  const { data } = await axios.patch(url, { is_done }, buildAuthHeaders());
  return mapServerProtocol(data?.data ?? data);
};

export const deleteDoctorProtocolsoin = async (doctorId, id) => {
  const url = `${API_BASE_URL}doctor/${doctorId}/soin/protocols/${id}`;
  await axios.delete(url, buildAuthHeaders());
  return true;
};

// (Optionnel) helper dédié pour le commentaire
export const setDoctorProtocolsoinComment = async (doctorId, id, comment) => {
  return updateDoctorProtocolsoin(doctorId, id, { comment });
};

// ✅ Normalise les 2 formats possibles:
// - { success: true, data: { "YYYY-MM-DD": number, ... } }
// - { data: [{ day_key, dette }], total }
// - { success: true, data: [{...}], total }
// - (fallback) { data: {...} } sans total

export async function listDebtsLastPerDayApi(
  doctorId,
  { patient_id, start, end } = {}
) {
  let url = `${API_BASE_URL}doctor/${doctorId}/patients/${patient_id}/debts/last-per-day`;
  const params = new URLSearchParams();
  if (start) params.set("start", start);
  if (end) params.set("end", end);
  const qs = params.toString();
  if (qs) url += `?${qs}`;

  const rs = await fetch(url, { method: "GET", headers: { Accept: "application/json" } });
  if (!rs.ok) throw new Error(`HTTP ${rs.status}`);

  const raw = await rs.json();
  const payload = raw && raw.success ? raw.data : raw?.data ?? raw;

  let data = [];
  let total = (raw && raw.total != null) ? Number(raw.total) : undefined;

  if (Array.isArray(payload)) {
    // Format déjà en tableau
    data = payload.map(x => ({
      day_key: String(x.day_key),
      dette: Number(x.dette || 0),
    }));
  } else if (payload && typeof payload === "object") {
    // Format objet { "YYYY-MM-DD": number, ... }
    data = Object.entries(payload).map(([day_key, dette]) => ({
      day_key: String(day_key),
      dette: Number(dette || 0),
    }));
  } else {
    data = [];
  }

  // Trie décroissant par date (optionnel)
  data.sort((a, b) => (a.day_key < b.day_key ? 1 : -1));

  // Calcule total si absent
  if (typeof total === "undefined") {
    total = data.reduce((s, x) => s + Number(x.dette || 0), 0);
  }

  return { data, total: Number(total || 0) };
}

export async function getDebtLastApi(
  doctorId,
  { patient_id, day_key } = {}
) {
  let url = `${API_BASE_URL}doctor/${doctorId}/patients/${patient_id}/debts/last`;
  if (day_key) url += `?day_key=${encodeURIComponent(day_key)}`;

  const rs = await fetch(url, { method: "GET", headers: { Accept: "application/json" } });
  if (!rs.ok) throw new Error(`HTTP ${rs.status}`);

  const raw = await rs.json();
  const payload = raw && raw.success ? raw.data : raw?.data ?? raw;

  // Accepte plusieurs shapes:
  // - { day_key, dette }
  // - { dette }
  // - number (dette brute)
  if (payload && typeof payload === "object" && "dette" in payload) {
    return { day_key: payload.day_key ?? day_key ?? null, dette: Number(payload.dette || 0) };
  }
  if (typeof payload === "number") {
    return { day_key: day_key ?? null, dette: Number(payload || 0) };
  }
  return { day_key: day_key ?? null, dette: 0 };
}



function getDoctorIdFromLoginInfo() {
  try {
    const raw = localStorage.getItem("doctolikLoginInfo");
    if (!raw) return null;
    const v = JSON.parse(raw);
    // multi-formats possibles
    return (
      v?.users?.id ??
      v?.user?.id ??
      v?.doctor?.id ??
      v?.data?.user?.id ??
      null
    );
  } catch {
    return null;
  }
}

function buildAuthHeaders() {
  try {
    const raw = localStorage.getItem("doctolikLoginInfo");
    if (!raw) return {};
    const v = JSON.parse(raw);
    const tok = v?.authorisation?.token ?? v?.authorization?.token ?? v?.token;
    return tok
      ? { headers: { Authorization: `Bearer ${tok}`, "Cache-Control": "no-cache" } }
      : {};
  } catch {
    return {};
  }
}





export const listAntecedentConfigsApi = async (doctorId) => {
  const url = `${API_BASE_URL}doctor/${doctorId}/config/antecedents`;
  return axios.get(url, getHeader()); // attendu: { data: { data: [{id,item,option1..16}, ...] } }
};

export const saveAntecedentConfigApi = async (doctorId, payload) => {
  const url = `${API_BASE_URL}doctor/${doctorId}/config/antecedents/save`;
  return axios.post(url, payload, getHeader()); // payload: { id?, item, option1..option16? }
};

export const deleteAntecedentConfigApi = async (doctorId, id) => {
  const url = `${API_BASE_URL}doctor/${doctorId}/config/antecedents/${id}`;
  return axios.delete(url, getHeader());
};




// stock-utiliser API (Front)
export const listStockUtililiserApi = async (doctorId, { patientId, appointmentId, search } = {}) => {
  const url = `${API_BASE_URL}doctor/${doctorId}/stock-utiliser`;
  const params = {};
  if (patientId) params.patient_id = patientId;
  if (appointmentId != null) params.appointment_id = appointmentId;
  if (search) params.search = search;
  const { data } = await axios.get(url, { ...buildAuthHeaders(), params });
  // attendu: { success: true, data: [...] }
  return Array.isArray(data?.data) ? data.data : [];
};

export const getStockUtililiserApi = async (doctorId, id) => {
  const url = `${API_BASE_URL}doctor/${doctorId}/stock-utiliser/${id}`;
  const { data } = await axios.get(url, buildAuthHeaders());
  return data?.data;
};

export const createStockUtililiserApi = async (doctorId, payload) => {
  // payload: { id_patient, nom, qte, code }
  const url = `${API_BASE_URL}doctor/${doctorId}/stock-utiliser`;
  const { data } = await axios.post(url, payload, buildAuthHeaders());
  return data?.data; // {id, id_doctor, id_patient, nom, qte, code, ...}
};

export const updateStockUtililiserApi = async (doctorId, id, payload) => {
  const url = `${API_BASE_URL}doctor/${doctorId}/stock-utiliser/${id}`;
  const { data } = await axios.patch(url, payload, buildAuthHeaders());
  return data?.data;
};

export const deleteStockUtililiserApi = async (doctorId, id) => {
  const url = `${API_BASE_URL}doctor/${doctorId}/stock-utiliser/${id}`;
  const { data } = await axios.delete(url, buildAuthHeaders());
  return !!data?.success;
};

export async function imputationForDateApi(doctorId, params = {}) {
  const qs = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") qs.append(k, String(v));
  });

  const url = `${API_BASE_URL}doctor/${doctorId}/payments/imputation-for-date?${qs.toString()}`;
  const rs = await fetch(url, { method: "GET", headers: { Accept: "application/json" } });
  if (!rs.ok) throw new Error(`HTTP ${rs.status}`);

  const json = await rs.json();
  const items = Array.isArray(json?.items) ? json.items : [];

  // 1) appointment_id prioritaire (params → payload → items[0])
  const appointmentIdFromPayload =
    params?.appointment_id ??
    json?.appointment_id ??
    (items?.[0]?.appointment_id ?? null);

  // 2) day_key (params → payload → créé depuis created_at si dispo)
  let dayKeyFromPayload =
    params?.day_key ??
    (json?.day_key ? String(json.day_key).slice(0, 10) : null);

  if (!dayKeyFromPayload && items?.[0]?.created_at) {
    // created_at: "YYYY-MM-DD HH:mm:ss"
    const iso = items[0].created_at.replace(" ", "T");
    // ⚠️ UTC → si tu veux strictement le jour local, remplace toISOString par un util local (ymdLocalFromDate)
    dayKeyFromPayload = new Date(iso).toISOString().slice(0, 10);
  }

  return {
    day_key: dayKeyFromPayload,
    paid_total: Number(json?.paid_total ?? json?.total ?? 0),
    paid_last: Number(json?.paid_last ?? json?.last ?? 0),
    items,
    appointment_id: appointmentIdFromPayload != null ? Number(appointmentIdFromPayload) : null,
  };
}

export async function imputationForAppointmentApi(doctorId, params = {}) {
  if (!doctorId) throw new Error("doctorId manquant");
  if (!params?.patient_id) throw new Error("patient_id manquant");
  if (!params?.appointment_id) throw new Error("appointment_id manquant");

  const qs = new URLSearchParams();
  qs.append("patient_id", String(params.patient_id));
  qs.append("appointment_id", String(params.appointment_id));

  const url = `${API_BASE_URL}doctor/${doctorId}/payments/imputation-for-date?${qs}`;
  const rs = await fetch(url, { method: "GET", headers: { Accept: "application/json" } });
  if (!rs.ok) throw new Error(`HTTP ${rs.status}`);

  const j = await rs.json();
  return {
    appointment_id: Number(j?.appointment_id ?? params.appointment_id),
    paid_total: Number(j?.paid_total ?? 0),
    paid_last: Number(j?.paid_last ?? 0),
    items: Array.isArray(j?.items) ? j.items : [],
  };
}

export async function getAnnulationResteApi(
  doctorId,
  { patient_id, appointment_id = null, from = null, to = null } = {}
) {
  const url = `${API_BASE_URL}doctor/${doctorId}/annulation/reste`;
  const qs = new URLSearchParams();
  if (patient_id != null) qs.set("patient_id", patient_id);
  if (appointment_id != null) qs.set("appointment_id", appointment_id);
  if (from) qs.set("from", String(from).slice(0, 10));
  if (to) qs.set("to", String(to).slice(0, 10));

  const rs = await fetch(`${url}?${qs.toString()}`, {
    method: "GET",
    headers: { Accept: "application/json" },
  });

  let json = {};
  try { json = await rs.json(); } catch { }

  if (!rs.ok) {
    const msg = json?.message || `HTTP ${rs.status}`;
    throw new Error(msg);
  }

  const d = json?.data || {};
  return {
    patient_id: Number(patient_id ?? 0),
    appointment_id: d?.scope?.appointment_id ?? appointment_id ?? null,
    from: d?.scope?.from ?? from ?? null,
    to: d?.scope?.to ?? to ?? null,
    // le back renvoie { data: { reste: 80, scope:{...} } }
    reste: Number(d?.reste ?? d?.reste_a_payer ?? 0),
    raw: json,
  };
}

// === Annulation: flip (paid -> reste_a_payer) sur la ligne __ANNULATION__
export async function flipAnnulationPaidToResteApi(
  doctorId,
  { patient_id, from = null, to = null } = {}
) {
  const url = `${API_BASE_URL}doctor/${doctorId}/payments/annulation/flip`;
  const payload = { patient_id, from, to };

  const rs = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(payload),
  });

  const json = await rs.json().catch(() => ({}));
  if (!rs.ok) {
    const msg = json?.message || `HTTP ${rs.status}`;
    throw new Error(msg);
  }

  return {
    status: json?.success ? "ok" : (json?.status ?? "ok"),
    annulation_id: Number(json?.data?.annulation_id ?? json?.annulation_id ?? 0),
    period_sig: json?.data?.period_sig ?? json?.period_sig ?? null,
    old: json?.data?.old ?? null,
    new: json?.data?.new ?? null,
    updated_at: json?.data?.updated_at ?? null,
    raw: json,
  };
}

// Lister paginé/filtré
export const listPaymentsApi = async (doctorId, params = {}) => {
  const url = `${API_BASE_URL}doctor/${doctorId}/payments`;
  const { data } = await axios.get(url, { ...buildAuthHeaders(), params });
  return data; // { success, data: items[], meta? }
};

export const listPaymentsAllApi = async (doctorId, params = {}) => {
  // tu peux aussi utiliser /payments/tous si tu veux tout sans pagination
  const url = `${API_BASE_URL}doctor/${doctorId}/payments`;
  const qp = {};

  // patient
  const pid = params.patient_id ?? params.id_patient ?? params.patientId;
  if (pid) qp.patient_id = Number(pid);

  // bornes / autres
  if (params.from) qp.from = String(params.from).slice(0, 10);
  if (params.to) qp.to = String(params.to).slice(0, 10);
  if (params.q) qp.q = String(params.q);
  if (params.fully_paid != null) qp.fully_paid = Number(params.fully_paid ? 1 : 0);
  if (params.is_annule != null) qp.is_annule = Number(params.is_annule ? 1 : 0);

  // ✅ IMPORTANT : inclure systématiquement les imputations
  qp.include_imputation = 1;

  // (optionnels si tu veux forcer des cas)
  if (params.only_imputation != null) qp.only_imputation = Number(params.only_imputation ? 1 : 0);
  if (params.exclude_imputation != null) qp.exclude_imputation = Number(params.exclude_imputation ? 1 : 0);
  if (params.only_past != null) qp.only_past = Number(params.only_past ? 1 : 0);

  const resp = await axios.get(url, { ...getHeader(), params: qp });
  const payload = resp?.data;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload)) return payload;
  return [];
};



// Afficher un paiement
export const showPaymentApi = async (doctorId, id) => {
  const url = `${API_BASE_URL}doctor/${doctorId}/payments/${id}`;
  const { data } = await axios.get(url, buildAuthHeaders());
  return data?.data;
};

// api/payments.js

export const createPaymentApi = async (doctorId, payload) => {
  const url = `${API_BASE_URL}doctor/${doctorId}/payments`;

  // ⚠️ on enlève uniquement les "undefined" (on garde null/0/false si tu veux les envoyer)
  const body = Object.fromEntries(
    Object.entries(payload).filter(([, v]) => v !== undefined)
  );

  const { data } = await axios.post(url, body, buildAuthHeaders());
  return data?.data;
};


export const updatePaymentApi = async (doctorId, id, payload) => {
  const url = `${API_BASE_URL}doctor/${doctorId}/payments/${id}`;
  const { data } = await axios.patch(url, payload, buildAuthHeaders());
  return data?.data;
};
export const getLastWeightApi = async (doctorId, patientId) => {
  try {
    const url = `${API_BASE_URL}doctor/${doctorId}/patient/${patientId}/last-weight`;
    const { data } = await axios.get(url, buildAuthHeaders());
    return data; // ou data?.data si ton API retourne { data: { ... } }
  } catch (error) {
    console.error("Erreur getLastWeightApi:", error);
    throw error; // pour gérer l'erreur côté front
  }
};


// Supprimer
export const deletePaymentApi = async (doctorId, id) => {
  const url = `${API_BASE_URL}doctor/${doctorId}/payments/${id}`;
  const { data } = await axios.delete(url, buildAuthHeaders());
  return !!data?.success;
};

// Generate PDF Invoice
export const generatePaymentInvoiceApi = async (doctorId, paymentId) => {
  const url = `${API_BASE_URL}doctor/${doctorId}/payments/${paymentId}/invoice`;
  const response = await axios.get(url, buildAuthHeaders());
  return response;
};

// api/payments.js
// apiService.jsx

/* ================== API ================== */
export async function cancelDebtApi(
  doctorId,
  {
    patient_id,
    appointment_id = null,
    from = null,
    to = null,
    only_today = false,
    all_days = false,
    include_cancelled = false,
  } = {}
) {
  const url = `${API_BASE_URL}doctor/${doctorId}/payments/cancel-debt`;

  // hasAppt = entier positif
  const apptId = Number(appointment_id ?? 0);
  const hasAppt = Number.isInteger(apptId) && apptId > 0;

  // Construire le payload sans clés null/undefined
  const payload = hasAppt
    ? { patient_id, appointment_id: apptId, include_cancelled: !!include_cancelled }
    : {
      patient_id,
      from: from ?? null,
      to: to ?? null,
      only_today: !!only_today,
      all_days: !!all_days,
      include_cancelled: !!include_cancelled,
    };

  // Nettoyage des null/undefined
  Object.keys(payload).forEach((k) => {
    if (payload[k] === null || payload[k] === undefined) delete payload[k];
  });

  const rs = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(payload),
  });

  let json = {};
  try { json = await rs.json(); } catch (_) { }

  if (!rs.ok) {
    const msg = json?.message || `HTTP ${rs.status}`;
    throw new Error(msg);
  }

  // Backend: { success: true, data: {...} }
  const root = json?.data ?? json;

  return {
    success: !!json?.success,
    status: root?.status ?? "ok",
    scope: root?.scope ?? {},
    affectedDays: root?.affected_days ?? [],
    breakdown: root?.breakdown ?? null,
    transfer: root?.transfer ?? null,
    annulation: root?.annulation ?? null,
    note: root?.note ?? "",
    // compat éventuelle si un ancien code lisait remarks:
    remarks: root?.remarks ?? {},
    raw: json,
  };
}
export const addWeightApi = async (doctorId, patientId, values) => {
  // values: FormData or object
  return await axios.post(API_BASE_URL + `doctors/${doctorId}/patients/${patientId}/weights`, values, getHeader());
};

export const getWeightApi = async (id) => {
  return await axios.get(API_BASE_URL + `weights/${id}`, getHeader());
};

export const updateWeightApi = async (id, values) => {
  // use put (or patch) depending on your backend
  return await axios.put(API_BASE_URL + `weights/${id}`, values, getHeader());
};
export const listPatientWeights = (doctorId, patientId) => {
  if (!doctorId || !patientId) {
    return Promise.reject(new Error("doctorId and patientId are required"));
  }
  const url = `${API_BASE_URL}doctors/${doctorId}/patients/${patientId}/weights`;
  return axios.get(url, getHeader());
};
export const getNationalUsersApi = (doctorId) => {
  if (!doctorId) {
    return Promise.reject(new Error("doctorId is required"));
  }

  const url = `${API_BASE_URL}doctors/national-users`;
  return axios.get(url, getHeader());
};

export const listPatientWeightss = (doctorId, patientId, appointmentId) => {
  if (!doctorId || !patientId) {
    return Promise.reject(new Error("doctorId and patientId are required"));
  }
  const url = `${API_BASE_URL}doctors/${doctorId}/patients/${patientId}/weightss`;
  const params = appointmentId ? { appointment_id: appointmentId } : {};
  return axios.get(url, { ...getHeader(), params });
};

export const deleteWeightApi = (id) => {
  return axios.delete(API_BASE_URL + `weights/${id}`, getHeader());
};
export async function finalDebtForDateApi(doctorId, params = {}) {
  const q = new URLSearchParams(params).toString();
  const url = `${API_BASE_URL}doctor/${doctorId}/payments/final-debt-for-date?${q}`;
  const rs = await fetch(url, { headers: { Accept: "application/json" } });
  if (!rs.ok) throw new Error(`HTTP ${rs.status}`);
  const json = await rs.json();
  return json?.data || { computed: 0, cancelled: 0, final: 0 };
}


export const listDoctorStocksApi = async (doctorId, { search } = {}) => {
  const url = `${API_BASE_URL}doctor/${doctorId}/stocks`;
  return axios.get(url, { ...getHeader(), params: search ? { search } : {} });
};
export const moveDoctorStockApi = async (doctorId, payload) => {
  const url = `${API_BASE_URL}doctor/${doctorId}/stocks/move`;
  try {
    return await axios.post(url, payload, getHeader());
  } catch (err) {
    const resp = err?.response;
    console.error("MOVE 422 payload =", JSON.stringify(payload, null, 2));
    console.error("MOVE 422 status  =", resp?.status);
    console.error("MOVE 422 data    =", JSON.stringify(resp?.data, null, 2));
    // remonte un message clair
    const firstError =
      resp?.data?.errors
        ? Object.values(resp.data.errors).flat()[0]
        : resp?.data?.message || err.message;
    throw new Error(firstError || "Validation error");
  }
};

export async function debtsPerDayApi(doctorId, params = {}) {
  const qs = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") qs.append(k, String(v));
  });
  const url = `${API_BASE_URL}doctor/${doctorId}/payments/debts-per-day?${qs.toString()}`;
  const rs = await fetch(url, { method: "GET", headers: { Accept: "application/json" } });
  if (!rs.ok) throw new Error(`HTTP ${rs.status}`);
  const json = await rs.json();
  return {
    data: Array.isArray(json?.data) ? json.data : [],
    total: Number(json?.total ?? 0),
  };
}

// apiService - chart observations (supports optional doctorId + patientId in route)
const chartsBase = (doctorId, patientId) => {
  if (!doctorId || !patientId) throw new Error("doctorId et patientId sont requis pour chartsBase :" + JSON.stringify({ doctorId, patientId }));
  return `${API_BASE_URL}doctor/${doctorId}/patient/${patientId}/obs/charts`;
};
export const fetchChartssList = async (doctorId = null, patientId = null, params = {}) => {
  const url = chartsBase(doctorId, patientId);
  try {
    // Construire les paramètres de requête pour filtrer par appointment_id
    const queryParams = {};
    if (params?.appointmentId) {
      queryParams.appointment_id = params.appointmentId;
    }

    const { data } = await axios.get(url, {
      ...getHeader(),
      params: queryParams
    });
    const rawList = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);

    return rawList.map((r) => ({
      id: r.id,
      nom: r.nom ?? r.parametre ?? "",
      parametre: r.parametre ?? r.nom ?? "",
      unite: r.unite ?? "",
      valeur_min: r.valeur_min ?? null,
      valeur_max: r.valeur_max ?? null,
      frequence_typique: r.frequence_typique ?? null,
      doctor_id: r.doctor_id ?? null,
      patient_id: r.patient_id ?? null,
      appointment_id: r.appointment_id ?? null,
      raw: r,
    }));
  } catch (err) {
    console.error("fetchChartsList error:", err);
    throw err;
  }
};


// CREATE
export const createChartObservation = async (payload = {}, doctorId, patientId) => {
  const url = chartsBase(doctorId, patientId);
  try {
    const { data } = await axios.post(url, payload, getHeader());
    const item = data?.data ?? data ?? null;
    if (!item) return null;
    return {
      id: item.id,
      nom: item.nom ?? item.parametre ?? "",
      parametre: item.parametre ?? item.nom ?? "",
      unite: item.unite ?? "",
      valeur_min: item.valeur_min ?? null,
      valeur_max: item.valeur_max ?? null,
      frequence_typique: item.frequence_typique ?? null,
      doctor_id: item.doctor_id ?? null,
      patient_id: item.patient_id ?? null,
      raw: item,
    };
  } catch (err) {
    console.error("createChartObservation error:", err);
    throw err;
  }
};

// GET
export const getChartObservation = async (id, doctorId, patientId) => {
  const url = `${chartsBase(doctorId, patientId)}/${id}`;
  try {
    const { data } = await axios.get(url, getHeader());
    const item = data?.data ?? data ?? null;
    if (!item) return null;
    return {
      id: item.id,
      nom: item.nom ?? item.parametre ?? "",
      parametre: item.parametre ?? item.nom ?? "",
      unite: item.unite ?? "",
      valeur_min: item.valeur_min ?? null,
      valeur_max: item.valeur_max ?? null,
      frequence_typique: item.frequence_typique ?? null,
      doctor_id: item.doctor_id ?? null,
      patient_id: item.patient_id ?? null,
      raw: item,
    };
  } catch (err) {
    console.error("getChartObservation error:", err);
    throw err;
  }
};

// DELETE
export const deleteChartObservation = async (id, doctorId, patientId) => {
  const url = `${chartsBase(doctorId, patientId)}/${id}`;
  try {
    const { data } = await axios.delete(url, getHeader());
    if (data && typeof data.res !== "undefined") {
      if (!data.res) throw new Error(data.msg || "Property could not be deleted");
      return true;
    }
    return true;
  } catch (err) {
    console.error("deleteChartObservation error:", err);
    throw err;
  }
};
export const getChartsConfigApi = (doctorId, configId) => {
  return axios.get(
    API_BASE_URL + `doctors/${doctorId}/charts-config/${configId}`,
    getHeader()
  );
};
// Liste de toutes les configurations pour un doctor
const toNumberOrNull = (v) => {
  if (v === null || v === undefined) return null;
  if (typeof v === "number") return Number.isFinite(v) ? v : null;
  const s = String(v).trim().replace(",", ".").replace(/\s+/g, "");
  const n = parseFloat(s);
  return Number.isFinite(n) ? n : null;
};

export const fetchChartsssList = async (doctorId) => {
  try {
    const res = await axios.get(API_BASE_URL + `doctors/${doctorId}/charts-config`, getHeader());

    // récupérer le tableau
    const rawList = Array.isArray(res?.data?.data) ? res.data.data : (Array.isArray(res?.data) ? res.data : []);

    // mapper exactement comme fetchChartssList
    return rawList.map((r) => ({
      id: r.id,
      nom: r.nom ?? r.parametre ?? "",
      parametre: r.parametre ?? r.nom ?? "",
      unite: r.unite ?? "",
      // on utilise valeur_min / valeur_max comme dans fetchChartssList
      valeur_min: toNumberOrNull(r.minval ?? r.valeur_min ?? null),
      valeur_max: toNumberOrNull(r.maxval ?? r.valeur_max ?? null),
      frequence_typique: r.frequence_typique ?? null,
      doctor_id: r.doctor_id ?? null,
      patient_id: null,
      raw: r,
    }));
  } catch (err) {
    console.error("fetchChartsssList error:", err);
    throw err;
  }
};

export const createChartsConfigApi = (doctorId, data) => {
  // data = { parametre, unite, minval, maxval }
  return axios.post(
    API_BASE_URL + `doctors/${doctorId}/charts-config`,
    data,
    getHeader()
  );
};
export const updateChartsConfigApi = (doctorId, configId, data) => {
  // data = { parametre?, unite?, minval?, maxval? }
  return axios.put(
    API_BASE_URL + `doctors/${doctorId}/charts-config/${configId}`,
    data,
    getHeader()
  );
};
export const deleteChartsConfigApi = (doctorId, configId) => {
  return axios.delete(
    API_BASE_URL + `doctors/${doctorId}/charts-config/${configId}`,
    getHeader()
  );
};
const pickString = (...values) => {
  for (let v of values) if (v != null) return String(v).trim();
  return "";
};



export const createPatientApi = async (doctorId, payload) => {
  const url = `${doctorBase(doctorId)}/patients`;
  const { data } = await axios.post(url, payload, getHeader());
  return data.data;
};

// 3️⃣ Mettre à jour
export const updatePatientApi = async (doctorId, patientId, payload) => {
  const url = `${doctorBase(doctorId)}/patients/${patientId}`;
  const { data } = await axios.put(url, payload, getHeader());
  return data.data;
};
export const deletePatientApi = async (doctorId, patientId) => {
  const url = `${doctorBase(doctorId)}/patients/${patientId}`;
  const { data } = await axios.delete(url, getHeader());
  return data?.success === true;
};
export const fetchAntecedentOptionsByTitle = async (titre) => {
  const encoded = encodeURIComponent((titre ?? '').trim());

  // ⚠️ Vérifie le bon chemin. Si ton route correct est /api/doctor/antecedents/{titre}/op,
  // utilise la ligne suivante. Sinon garde /doctor/doctor/... si c'est vraiment ta route.
  const url = `${API_BASE_URL}doctor/doctor/antecedents/${encoded}/op`;
  // const url = `${API_BASE_URL}doctor/doctor/antecedents/${encoded}/op`; // ← seulement si ton API est vraiment comme ça

  const { data } = await axios.get(url, getHeader());

  // Attendu (exemple Postman):
  // { res:true, msg:"", data: { titre: "Dyslipidémie", options: ["Léger","Modéré","Sévère"] } }
  const payload = data?.data;

  if (Array.isArray(payload)) {
    // vieux format fallback: ["Léger","Modéré"]
    return payload;
  }
  if (payload && Array.isArray(payload.options)) {
    return payload.options;
  }

  return [];
};

// Fetch cities and municipalities
export const getCitiesMunicipalitiesApi = async () => {
  try {
    const response = await axios.get(API_BASE_URL + `v1/cities-municipalities`);
    return response;
  } catch (error) {
    console.error('Error fetching cities and municipalities:', error);
    throw error;
  }
};

// ==================== PAYMENT MANAGEMENT API ====================

// Get payment by appointment ID
export const getPaymentByAppointmentApi = async (appointmentId) => {
  return axios.get(`${API_BASE_URL}v1/payments/appointment/${appointmentId}`, getHeader());
};

// Get patient payment history
export const getPatientPaymentHistoryApi = async (patientId, includeOld = false) => {
  return axios.get(`${API_BASE_URL}v1/payments/patient/${patientId}`, {
    ...getHeader(),
    params: { include_old: includeOld }
  });
};

// Get payment statistics
export const getPaymentStatisticsApi = async (params = {}) => {
  return axios.get(`${API_BASE_URL}v1/payments/statistics`, {
    ...getHeader(),
    params
  });
};

// Add service to payment
export const addServiceToPaymentApi = async (paymentId, payload) => {
  return axios.post(`${API_BASE_URL}v1/payments/${paymentId}/services`, payload, getHeader());
};

// Remove service from payment
export const removeServiceFromPaymentApi = async (paymentId, serviceId) => {
  return axios.delete(`${API_BASE_URL}v1/payments/${paymentId}/services/${serviceId}`, getHeader());
};

// Update service in payment
export const updateServiceInPaymentApi = async (paymentId, serviceId, payload) => {
  return axios.put(`${API_BASE_URL}v1/payments/${paymentId}/services/${serviceId}`, payload, getHeader());
};

// Record payment
export const recordPaymentApi = async (paymentId, payload) => {
  return axios.post(`${API_BASE_URL}v1/payments/${paymentId}/record-payment`, payload, getHeader());
};

// Update payment history
export const updatePaymentHistoryApi = async (paymentId, historyId, payload) => {
  return axios.put(`${API_BASE_URL}v1/payments/${paymentId}/history/${historyId}`, payload, getHeader());
};

// Delete payment history
export const deletePaymentHistoryApi = async (paymentId, historyId) => {
  return axios.delete(`${API_BASE_URL}v1/payments/${paymentId}/history/${historyId}`, getHeader());
};

// Clear all patient debts
export const clearAllPatientDebtsApi = async (patientId, payload) => {
  return axios.post(`${API_BASE_URL}v1/payments/patient/${patientId}/clear-all-debts`, payload, getHeader());
};

// Get patient debts
export const getPatientDebtsApi = async (params = {}) => {
  return axios.get(`${API_BASE_URL}v1/payments/debts`, {
    ...getHeader(),
    params
  });
};

// Update payment notes
export const updatePaymentNotesApi = async (paymentId, notes) => {
  return axios.patch(`${API_BASE_URL}v1/payments/${paymentId}/notes`, { notes }, getHeader());
};

// Get payment reports
export const getPaymentReportsApi = async (params = {}) => {
  return axios.get(`${API_BASE_URL}v1/payments/reports`, {
    ...getHeader(),
    params
  });
};

// Cancel debts (Annulation)
export const cancelPatientDebtsApi = async (patientId, payload) => {
  return axios.post(`${API_BASE_URL}v1/payments/patient/${patientId}/cancel-debts`, payload, getHeader());
};

// ==================== SERVICE CATALOG API ====================

// Get all services
export const getServicesApi = async (params = {}) => {
  return axios.get(`${API_BASE_URL}v1/services`, {
    ...getHeader(),
    params
  });
};

// Get paginated services
export const getPaginatedServicesApi = async (params = {}) => {
  return axios.get(`${API_BASE_URL}v1/services/paginated`, {
    ...getHeader(),
    params
  });
};

// Get single service
export const getSingleServiceApi = async (serviceId) => {
  return axios.get(`${API_BASE_URL}v1/services/${serviceId}`, getHeader());
};

// Create service
export const createServiceApi = async (payload) => {
  return axios.post(`${API_BASE_URL}v1/services`, payload, getHeader());
};

// Update service
export const updateServiceApi = async (serviceId, payload) => {
  return axios.put(`${API_BASE_URL}v1/services/${serviceId}`, payload, getHeader());
};

// Delete service
export const deleteServiceApi = async (serviceId) => {
  return axios.delete(`${API_BASE_URL}v1/services/${serviceId}`, getHeader());
};

// Get service categories
export const getServiceCategoriesApi = async () => {
  return axios.get(`${API_BASE_URL}v1/services/categories`);
};

// Get services by category
export const getServicesByCategoryApi = async (category) => {
  return axios.get(`${API_BASE_URL}v1/services/category/${category}`);
};

// Search services
export const searchServicesApi = async (query, params = {}) => {
  return axios.get(`${API_BASE_URL}v1/services/search`, {
    ...getHeader(),
    params: { q: query, ...params }
  });
};

// Get popular services
export const getPopularServicesApi = async (params = {}) => {
  return axios.get(`${API_BASE_URL}v1/services/popular`, {
    ...getHeader(),
    params
  });
};

// this section is for hot fixes and temporary endpoints that may not be part of the main API contract. Use with caution and check for updates regularly.

export const getDoctorChartsForPatientApi = async (doctorId, patientId) => {
  // api_base_url/doctor/doctor_id/patient/patient_id/obs/charts
  const url = `${API_BASE_URL}doctor/${doctorId}/patient/${patientId}/obs/charts`;

  const { data } = await axios.get(url, getHeader());
  return Array.isArray(data?.data) ? data.data : [];
}


export const getFullChartsList = async () => {
  // api_base_url/doctor/charts
  const { data } = await axios.get(`${API_BASE_URL}doctor/charts`, getHeader());
  return Array.isArray(data?.data) ? data.data : [];
}

// In-consultation recorder — server-side OpenAI proxy (see backend RecorderAiController).
// The key lives only in the backend .env; the browser never sees it.
export const recorderTranscribeApi = (formData) => {
  return axios.post(API_BASE_URL + `doctor/recorder/transcribe`, formData, getHeader());
};

export const recorderAnalyzeApi = (values) => {
  return axios.post(API_BASE_URL + `doctor/recorder/analyze`, values, getHeader());
};
